import { render, staticRenderFns } from "./InfoModuleRanking.vue?vue&type=template&id=1ee04b72&scoped=true&"
import script from "./InfoModuleRanking.vue?vue&type=script&lang=js&"
export * from "./InfoModuleRanking.vue?vue&type=script&lang=js&"
import style0 from "./InfoModuleRanking.vue?vue&type=style&index=0&id=1ee04b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee04b72",
  null
  
)

export default component.exports